(function() {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('ModalWaitCtrl', ModalWaitCtrl);

    ModalWaitCtrl.$inject = ['$scope', '$modalInstance', 'message', 'buttonText', 'title'];

    /**
     * Controller for a modal wait dialog with a single button to make it go away.
     */
    function ModalWaitCtrl($scope, $modalInstance, message, buttonText, title) {

        $scope.message = message || 'Loading...';
        $scope.buttonText = buttonText || 'Cancel';
        $scope.title = title;

        /**
         * Closes the dialog with an negative (Cancel) choice.
         */
        $scope.cancel = function() {
            $modalInstance.close('cancel');
        };
    }
})();